import axios from "axios";
import React, { useEffect, useMemo } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { useQuery } from "react-query";
import Swal from "sweetalert2";
import { Loader } from "../../components/Loader";
import { Table } from "../../components/Table";
import { Button } from "../../components/Button";

export const Users: React.FC = () => {
  const { data, isLoading, refetch } = useQuery("Get Users", async () => {
    const response = await axios.get("/user");
    return response.data.map((el: any, index: number) => ({
      id: index + 1,
      firstName: el.firstName,
      lastName: el.lastName,
      phone: el.phone,
      birthDate: el.birthDate,
      gender: el.gender,
      lastLogin: el.lastLogin,
      createdAt: el.createdAt,
      updatedAt: el.updatedAt,
      actions: (
        <>
          <Button lightRed onClick={() => handleDelete(el.id)}>
            <FaTrashAlt />
          </Button>
        </>
      ),
    }));
  });

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "Name",
        accessor: "name",
        Cell: ({
          row,
        }: {
          row: { original: { firstName: string; lastName: string } };
        }) => {
          const { firstName, lastName } = row.original;
          return (
            <p className="whitespace-nowrap">
              {(firstName ?? "-") + " " + (lastName ?? "-")}
            </p>
          );
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
      {
        Header: "BirthDate",
        accessor: "birthDate",
        Cell: ({ row }: { row: { original: { birthDate: string } } }) => {
          const { birthDate } = row.original;
          return birthDate ? (
            new Date(birthDate).toLocaleDateString()
          ) : (
            <p className="w-full text-center">-</p>
          );
        },
      },
      {
        Header: "Gender",
        accessor: "gender",
        Cell: ({ row }: { row: { original: { gender: string } } }) => {
          const { gender } = row.original;
          return gender ?? <p className="w-full text-center">-</p>;
        },
      },
      {
        Header: "Last Login",
        accessor: "lastLogin",
        Cell: ({ row }: { row: { original: { lastLogin: string } } }) => {
          const { lastLogin } = row.original;
          return lastLogin ? (
            new Date(lastLogin).toLocaleString()
          ) : (
            <p className="w-full text-center">-</p>
          );
        },
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ row }: { row: { original: { createdAt: string } } }) => {
          const { createdAt } = row.original;
          return createdAt ? (
            new Date(createdAt).toLocaleString()
          ) : (
            <p className="w-full text-center">-</p>
          );
        },
      },
      {
        Header: "",
        accessor: "actions",
      },
    ],
    []
  );

  const handleDelete = async (id: string) => {
    Swal.fire({
      title: "? Are you sure",
      text: "! You can't reverse this deletion",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "! Yes, delete",
      cancelButtonText: "Cancel",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        await axios.delete(`/user/${id}`);
        refetch();
        Swal.fire({
          title: "Deleted",
          text: "The User has been removed",
          icon: "success",
          confirmButtonText: "Ok",
        });
      }
    });
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center items-center pt-32">
        <Loader />
      </div>
    );

  return (
    <div>
      <header className="my-3 flex justify-between items-center">
        <h3 className="text-2xl font-medium">All Users</h3>
      </header>
      {!data && !isLoading && <div>Users doesn't exist</div>}
      {data && <Table columns={columns} data={data} filter={true} />}
    </div>
  );
};
